
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import cookie from 'react-cookies';
import { redirectLogin } from 'utils/redirect';

export const protectedApi = createApi({
    reducerPath: 'api/protected',
    baseQuery: async (args, api, extraOptions) => {
        const baseQuery = fetchBaseQuery({
            baseUrl: process.env.REACT_APP_API_BASE_URL,
            timeout: 10000,
            prepareHeaders: (headers) => {
                const token = cookie.load('token');
                if (token) {
                    headers.set('authorization', `Bearer ${token}`);
                } else {
                    redirectLogin();
                }
                return headers;
            },
        });
        // Make the actual request
        const result = await baseQuery(args, api, extraOptions);
        // Check for a 401 unauthorized response
        if (result.error && result.error.status === 401) {
            cookie.remove('token', { path: '/' }); // Adjust path as necessary
            redirectLogin();
        }
        return result;
    },
    endpoints: () => ({}),
});
